// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Q5Vd","alert":"SettungsInbox_alert__3RCeN"};